@if(!activeStore) {
    <div class="batch-details-container">
        <div class="fixed z-20 top-0 right-0 left-0 pl-5 pr-6 h-12 bg-green-500 w-full flex items-center justify-between font-bold">
            <div class="text-white">Batch Details</div>
            <div>
                <p-button
                    icon="pi pi-times" 
                    [rounded]="true" 
                    [text]="true" 
                    (click)="closeDialog()"
                    class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
            </div>
        </div>
        
        <div class="content-container bg-green-100 py-6 pt-[80px]"
            [style]="{'padding-bottom': batch?.status === 'available' || batch?.status === 'completed' ? '380px' : '0px'}">
            <p-timeline [value]="batch?.optimizedRoute || []" layout="vertical" styleClass="customized-timeline">
                <ng-template #marker let-event>
                    <span class="flex min-w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm bg-green-500">
                        @if(event.name) {
                            <i class="pi pi-building"></i>
                        } @else {
                            <i class="pi pi-home"></i>
                        }
                    </span>
                </ng-template>
                <ng-template #content let-event>
                    @if(event.name) {
                        <div class="font-semibold pt-1 pb-3">
                            <span class="text-green-600">{{ event.name }}</span>
                        </div>
                        <div class="border-1 rounded-xl p-4 bg-gray-50">
                            <!-- Store Details -->
                            <div class="mb-3">
                                <div class="grid grid-cols-2 gap-2 text-xs">
                                    <div class="flex items-center gap-1">
                                        <i class="pi pi-shopping-bag text-gray-500"></i>
                                        <span>{{ event.orderCount || 0 }} orders</span>
                                    </div>
                                    <div class="flex items-center gap-1">
                                        <i class="pi pi-box text-gray-500"></i>
                                        <span>{{ event.itemsCount || 0 }} items</span>
                                    </div>
                                </div>
                            </div>
                            @if(batch?.status !== 'available') {
                                <div class="h-px bg-gray-100 my-2"></div>
                                @if(event.shoppingStatus === 'not_started') {
                                    <div class="flex gap-2 pt-2">
                                        <p-button 
                                        [icon]="'pi pi-shopping-cart'"
                                        [style]="{background: '#4D7935', width: '100%'}"
                                        class="w-full [&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                        (click)="startShopping(event)" 
                                        [label]="'Shop Now'"
                                        />
                                        <p-button 
                                        [icon]="'pi pi-directions'"
                                        [style]="{background: '#4D7935'}"
                                        class="[&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                        (click)="navigateToStore(event)" 
                                        [label]="'Navigate'"
                                        />
                                    </div>  
                                } @else if(event.shoppingStatus === 'in_progress') {
                                    <div class="flex gap-2 pt-2">
                                        <p-button 
                                            [icon]="'pi pi-shopping-cart'"
                                            [style]="{background: '#4D7935', width: '100%'}"
                                            class="w-full [&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                            (click)="continueShopping(event)"
                                            [label]="'Resume'"/>
                                        <p-button 
                                            [icon]="'pi pi-directions'"
                                            [style]="{background: '#4D7935'}"
                                            class="[&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                            (click)="navigateToStore(event)" 
                                            [label]="'Navigate'"/>
                                    </div>
                                } @else if(event.shoppingStatus === 'completed') {
                                    <div class="text-sm font-bold capitalize text-left flex items-center gap-2 pt-3 text-green-500"><i class="pi pi-check-circle text-green-500"></i> Shopping Completed <i class="pi pi-arrow-right text-green-500" (click)="continueShopping(event)"></i></div>
                                }
                            }
                        </div>
                    } @else {
                        <div class="font-semibold pt-1 pb-3">
                            <span class="text-green-600">Drop off</span>
                        </div>
                        <div class="border-1 rounded-xl p-4 bg-gray-50">
                            <div class="mb-3">
                                <div class="grid grid-cols-2 gap-2 text-xs">
                                    <div class="flex items-center gap-1">
                                        <i class="pi pi-box text-gray-500"></i>
                                        <span>{{ event.itemsCount || 0 }} items</span>
                                    </div>
                                    <div class="flex items-center gap-1">
                                        <i class="pi pi-receipt text-gray-500"></i>
                                        <span>{{ event.storeCount || 0 }} store receipts</span>
                                    </div>
                                </div>
                            </div>
                            <!-- show below only if status is in_progress -->
                            @if(batch?.status !== 'available') {
                                <div class="h-px bg-gray-100 my-2"></div>
                                <!-- show address -->
                                 <label class="text-xs font-light capitalize mb-1 text-gray-500">Address</label>
                                <div class="text-sm font-light capitalize mb-1">{{ event.fullAddress }}</div>
                                <div class="h-px bg-gray-100 my-2"></div>
                                @if(event.deliveryStatus === 'completed') {
                                    <div class="text-sm font-bold capitalize text-left flex items-center gap-2 pt-3 text-green-500"><i class="pi pi-check-circle text-green-500"></i> Delivery Completed</div>
                                } @else {
                                    <div class="flex gap-2 pt-2">
                                        <p-button 
                                        [icon]="'pi pi-truck'"
                                        [style]="{background: '#4D7935', width: '100%'}"
                                        class="w-full [&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                        (click)="completeDeliveryTasks(event)" 
                                        [label]="'Complete'"
                                        />
                                        <p-button 
                                        [icon]="'pi pi-directions'"
                                        [style]="{background: '#4D7935'}"
                                        class="[&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                        (click)="navigateToDropoff(event)"
                                        [label]="'Navigate'"
                                        />
                                    </div>
                                }
                            }
                        </div>
                    }
                </ng-template>
            </p-timeline>
        </div>

        <!-- show accept card only if status is available -->
        @if(batch?.status === 'available' || batch?.status === 'completed') {
            <div class="fixed bottom-0 left-0 right-0 bg-white border-t rounded-t-2xl shadow-xl z-10">
                <div class="batch-details-card">
                    <!-- Header Section -->
                    <div class="header-row flex items-center justify-between p-4 border-b">
                        <div class="flex items-center gap-2">
                            <i class="pi pi-home text-green-600 font-semibold"></i>
                            <span class="text-green-700 font-semibold">{{ batch?.orders?.length || 0 }} deliveries</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <i class="pi pi-directions text-green-600 font-semibold"></i>
                            <span class="text-green-700 font-semibold">{{ batch?.estimatedTravelDistanceInMiles ? (batch?.estimatedTravelDistanceInMiles | number:'1.1-1') : '0.0' }} mi</span>
                        </div>
                    </div>
                
                    <!-- Earnings Section -->
                    <div class="earnings-row flex flex-col items-center py-6">
                        <div class="text-xs text-gray-500 mb-1">Total Pay</div>
                        <div class="text-4xl font-bold text-green-700">${{ batch?.estimatedShopperPay?.toFixed(2) || '0.00' }}</div>
                        <div class="text-xs text-gray-500 mt-1">
                            ${{ ((batch?.estimatedShopperPay || 0) - (batch?.totalTip || 0)).toFixed(2) }} batch earnings + ${{ batch?.totalTip?.toFixed(2) || '0.00' }} tip
                        </div>
                        <div class="flex gap-2 mt-3">
                            @if(batch?.stores?.length) {
                                <span class="badge bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold">Multi store</span>
                            } @else {
                                <span class="badge bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold">Single store</span>
                            }
                            @if((batch?.estimatedHourlyPay || 0) > 15 || (batch?.estimatedShopperPay || 0) > 50) {
                                <span class="badge bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold">Heavy Pay</span>
                            }
                        </div>
                        <div class="flex gap-2 mt-3">
                            <span class="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs flex items-center gap-1">
                                <i class="pi pi-box"></i> {{ batch?.totalItems || 0 }} items
                            </span>
                            <span class="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs flex items-center gap-1">
                                <i class="pi pi-building"></i> {{ batch?.stores?.length || 0 }} stores
                            </span>
                            <span class="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs flex items-center gap-1">
                                <i class="pi pi-clock"></i> {{ batch?.estimatedTotalTimeInHours?.toFixed(0) || 0 }} hr
                            </span>
                        </div>
                    </div>   
                
                    <!-- Accept Button -->
                    @if(batch?.status === 'available') {
                    <div class="accept-btn-row px-6 py-6">
                        <p-button 
                            [style]="{background: '#4D7935', width: '100%'}"
                            class="w-full [&_button]:text-white [&_button]:border-0"
                            (click)="acceptBatch()" 
                            [disabled]="acceptBatchInProgress" 
                            [loading]="acceptBatchInProgress" 
                            [loadingIcon]="'pi pi-spinner pi-spin'"
                            [label]="'Accept'"
                        />
                    </div>
                    } @else if(batch?.status === 'completed') {
                        <div class="accept-btn-row px-6 py-6 flex items-center justify-center">
                            <div class="text-sm font-bold text-center gap-2 text-green-500"><i class="pi pi-check-circle text-green-500"></i> Thank you for successfully completing the batch! We appreciate your hard work.</div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
} @else if(activeStore) {
    <div class="batch-details-container bg-green-100 h-full">
        <div class="fixed z-20 top-0 right-0 left-0 pl-2 pr-6 h-12 bg-green-500 w-full flex items-center font-bold">
            <div>
                <p-button
                    icon="pi pi-chevron-left" 
                    [rounded]="true" 
                    [text]="true" 
                    (click)="goBackToBatchDetails()"
                    class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
            </div>
            <div class="text-white font-semibold">Shopping at {{ activeStore | titlecase }}</div>
        </div>
        <div class="content-container bg-green-100 py-6 mt-12">
            <!-- loop through activeStoreItemsByOrder and show the items and order id as title in a card view -->
            <div class="grid grid-cols-1 gap-4">
                @for(order of activeStoreItemsByOrder | keyvalue; track order.key; let i = $index;) {
                    <p-panel 
                        [header]="'Order: ' + order.value[0].orderNumber" 
                        [toggleable]="true"
                        [collapsed]="(activeStoreItemsByOrder | keyvalue).length > 1  ? true : false"
                        [collapseIcon]="ordersMetrics[order.key].allItemsMarked && ordersMetrics[order.key].hasReceipt ? 'pi pi-check-circle' : 'pi pi-chevron-down'"
                        [expandIcon]="ordersMetrics[order.key].allItemsMarked && ordersMetrics[order.key].hasReceipt ? 'pi pi-check-circle' : 'pi pi-chevron-up'"
                        [toggler]="'header'"
                        [style]="{'background-color': ['#FFFBCC', '#FFE0B2', '#E0F7FA', '#EDE0D4', '#F8F4FF'][i]}"
                        [ngClass]="{'completed-shopping': ordersMetrics[order.key].allItemsMarked && ordersMetrics[order.key].hasReceipt}">
                        <!-- <div class="flex flex-row justify-between"> -->
                            <div class="flex flex-col px-3 py-2">
                                <div class="text-xs font-medium capitalize mb-1">Customer Name: {{ order.value[0].customerDetails.name || 'Sreekanth' }}</div>
                                <div class="text-xs font-medium capitalize mb-1">Phone Number: {{ order.value[0].customerDetails.phoneNumber || '9876543210' }}</div>
                                <div class="text-sm font-bold capitalize mb-1">Grocery Preferences: {{ order.value[0].customerPreferences.organicVarient || 'Not Provided' }}</div>
                            </div>
                        <!-- </div> -->
                        <div class="grid grid-cols-1 gap-2">
                            @for (item of order.value; track item.id) {
                                <div class="p-3 border-bottom-1 border-gray-300 flex flex-row justify-content-between">
                                    <div class="flex-1">
                                        <div class="font-medium text-md"><span class="capitalize">{{ item.name }}</span></div>
                                        <div class="text-sm font-medium capitalize mb-1">@if(item.quantity){<span>{{item.quantity + ' ' + item.unit}}</span>}</div>
                                        @if(item.notes) {<div class="text-xs font-medium capitalize">{{item.notes}}</div>}
                                        @if(item.images?.length) {
                                            <div class="flex flex-wrap gap-2 mt-2">
                                                @for(image of item.images; track $index; let i = $index) {
                                                    <p-image [imageStyle]="{'border-radius': '8px', 'width': '60px', 'height': '60px'}" [src]="'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/app_icon%2Ficon.png?alt=media&token=9047486a-0c6c-4995-9f82-5a9886d59293'" alt="Image" width="60" height="60" [preview]="true" />
                                                }
                                            </div>
                                        }
                                        @if(item.shopperNotes) {
                                            <label class="text-xs font-light text-gray-500 mt-1">Shopper Notes</label>
                                            <div class="text-xs font-medium">{{item.shopperNotes}}</div>
                                        }
                                    </div>
                                    <div class="flex gap-2">
                                        <p-button
                                            icon="pi pi-clipboard" 
                                            severity="secondary"
                                            [size]="'small'"
                                            [rounded]="true"
                                            [outlined]="item.status === 'found' ? false : true"
                                            class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-gray-500"
                                            (click)="addShopperNotes(item)" />
                                        <p-button
                                            icon="pi pi-check" 
                                            severity="success"
                                            [size]="'small'"
                                            [rounded]="true"
                                            [outlined]="item.status === 'found' ? false : true"
                                            class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-green-500"
                                            (click)="markItemAsShopped(item)" />
                                        <p-button
                                            icon="pi pi-arrow-right-arrow-left" 
                                            severity="warn"
                                            [size]="'small'"
                                            [rounded]="true"
                                            [outlined]="item.status === 'replaced' ? false : true"
                                            class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-orange-500"
                                            (click)="markItemAsReplaced(item)" />
                                        <p-button
                                            icon="pi pi-ban" 
                                            severity="danger"
                                            [size]="'small'"
                                            [rounded]="true"
                                            [outlined]="item.status === 'not_found' ? false : true"
                                            class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-red-500"
                                            (click)="markItemAsNotFound(item)" />
                                    </div>
                                    
                                </div>
                            }
                            <!-- complete store shopping button -->
                            <div class="flex gap-2 mt-2 items-center">
                                @if(ordersMetrics[order.key].allItemsMarked) {
                                    <div class="text-sm font-bold capitalize text-left flex items-center gap-2 text-green-500"><i class="pi pi-check-circle text-green-500"></i> Shopping Completed</div>
                                } @else {
                                    <p-button 
                                    [icon]="'pi pi-shopping-cart'"
                                    [style]="{background: '#4D7935', width: '100%'}"
                                    class="w-full [&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                    (click)="markShoppingCompleted(order.key, activeStore || '')"
                                    [label]="'Mark as Done'" />
                                }
                                @if(!ordersMetrics[order.key].hasReceipt) {
                                    <p-button 
                                    [icon]="'pi pi-upload'"
                                    [style]="{background: '#4D7935', width: '100%'}"
                                    class="w-full [&_button]:text-white [&_button]:border-0 [&_button]:text-xs"
                                    (click)="showPreShoppingCompleteTasksModal(order.key, activeStore || '')"
                                    [label]="'Receipts'" />
                                }
                            </div>
                            @if(ordersMetrics[order.key].hasReceipt && batch?.status !== 'completed') {
                                <div class="flex">
                                    <p-button 
                                        link
                                        [style]="{'text-decoration': 'underline', 'color': '#4D7935'}"
                                        class="w-full [&_button]:border-0 [&_button]:text-xs"
                                        (click)="showPreShoppingCompleteTasksModal(order.key, activeStore || '')"
                                        [label]="'Add Additional Receipts'" />
                                </div>
                            }
                        </div>
                    </p-panel>
                }
            </div>  
        </div>
    </div>

}
<p-confirmdialog />





